import React, { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { openCart } from '../../../../store/cart-v2/modal/actionsToDo'
import IconButton from '../IconButton'
import path from '../../../../routesCustom'
import { hideNotificationCart } from '../../../../store/cart-v2/notification/actionsToDo'

const disabledOnPages = () => {
  const { DATOS_FACTURACION } = path.privatePath
  return [DATOS_FACTURACION]
}

const Component = ({ quantity, openNotification }) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const onClick = useCallback(() => {
    openNotification && dispatch(hideNotificationCart())
    dispatch(openCart())
  }, [openNotification])

  if (disabledOnPages().includes(pathname)) {
    return null
  }
  return (
    <IconButton
      onClick={onClick}
      iconName="icon-light-shopping-cart"
      badgeVisible={quantity > 0}
      badgeContent={quantity}
    />
  )
}

const MemoComponent = React.memo(Component)

const state = ({ cartStoreV2 }) => {
  return {
    typeNotification: cartStoreV2.notification.type,
    openNotification: cartStoreV2.notification.open,
    quantity: cartStoreV2.valorized.cart.totalQuantityItems,
  }
}
export default connect(state)(MemoComponent)
